export class MessageModel {
    public id: string;
    public createDate: any;
    public fromSubscriber: boolean;
    public isSeen: boolean;
    public messageText: string;
    public subscriberChatId: string;
}
